(() => {
  const elementName = 'essentials-complementary-products';
  if (customElements.get(elementName)) return;

  class EssentialsComplementaryProducts extends HTMLElement {
    connectedCallback() {
      if (this.hasAttribute('data-loaded') || this.loading) return;
      this.loading = true;
      this.controller = new AbortController();
      this.loadRecommendations(this.controller.signal);
    }

    disconnectedCallback() {
      this.controller?.abort();
      this.loading = false;
    }

    async loadRecommendations(signal) {
      try {
        const response = await fetch(this.dataset.recommendationsUrl, { signal });
        if (!response.ok) throw new Error('Recommendations unavailable');
        const content = new DOMParser().parseFromString(await response.text(), 'text/html');
        const recommendations = content.querySelector(elementName);
        if (!this.isConnected || signal.aborted) return;
        if (!recommendations?.querySelector('.ProductItem')) {
          this.closest('section').hidden = true;
          this.setAttribute('data-loaded', '');
          return;
        }
        this.replaceChildren(...recommendations.childNodes);
        this.setAttribute('data-loaded', '');
        this.closest('section').hidden = false;
      } catch (error) {
        if (error.name !== 'AbortError' && this.isConnected) this.closest('section').hidden = true;
      } finally {
        this.loading = false;
      }
    }
  }

  customElements.define(elementName, EssentialsComplementaryProducts);
})();
